import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AdminDatabasePage } from '@pages/admin';

/**
 * Admin Database Page
 *
 * Route: /:locale/admin/database
 */
export const Route = createFileRoute('/$locale/_authenticated/admin/database')({
  component: AdminDatabase,
  validateSearch: z.object({
    schema: z.string().optional(),
    table: z.string().optional(),
  }),
});

function AdminDatabase() {
  return <AdminDatabasePage />;
}
